import { ReactElement } from "react";
import Layout from "../components/layout";
import BannerList from "../components/Banners";

const BannerPage = (): ReactElement => {
  return (
    <Layout>
      <BannerList />
    </Layout>
  );
};

export default BannerPage;
